import { Ban, Info, type LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

type Tone = { icon: LucideIcon; className: string; role: 'status' | 'alert' };

const TONE: Record<'neutral' | 'blocked', Tone> = {
  neutral: {
    icon: Info,
    className: 'bg-primary-quiet text-primary-quiet-foreground',
    role: 'status',
  },
  blocked: {
    icon: Ban,
    className: 'bg-destructive-quiet text-destructive-quiet-foreground',
    role: 'alert',
  },
};

export function Callout(props: { children: ReactNode; tone?: 'neutral' | 'blocked' }): ReactNode {
  const { children, tone = 'neutral' } = props;
  const { icon: Icon, className, role } = TONE[tone];
  return (
    <div role={role} className={`flex items-center gap-1.5 rounded-lg p-lg ${className}`}>
      <Icon aria-hidden className="size-3.5 shrink-0" />
      <p className="text-caption">{children}</p>
    </div>
  );
}
